<!-- 导入门店 -->
<template>
  <div class="power">
    <div style="padding: 16px">
      <van-cell-group>
        <van-cell size="large" title="请上传Excel 表格" />
        <van-cell size="large" title="1. 上传仅支持 Excel 文件，且文件内只有一列门店编码，不能含有除此以外的其他信息，否则会上传失败；" />
        <van-cell size="large" title="2. 如果上传的Excel文件包括已经存在的门店，不会影响已经存在的数据；" />
        <van-cell size="large" title="3. 上传门店编码后会自动匹配开票客户；" />
        <van-cell size="large" :border="false" title="4. 门店编码示意：S196730" />
        <div class="flex-center" style="justify-content: center; padding: 16px 0">
          <van-uploader
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel"
            :after-read="afterRead"
            result-type="file"
            :before-read="beforeRead"
          >
            <van-button round style="width: 285px; background: linear-gradient(270deg, #306fe2 24.05%, #1f7dde 73.62%); color: #fff">上传</van-button>
          </van-uploader>
        </div>
      </van-cell-group>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      radio: "",
      activityId: "",
      uuId: "",
    };
  },
  methods: {
    beforeRead(file) {
      const name = file.name.toLowerCase().split(".").pop();
      console.log(name);
      if (["xls", "xlsx"].indexOf(name) === -1) {
        this.$Toast("只能上传.xls.xlsx类型的文件");
        return false;
      }
      return true;
    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      const param = new FormData();
      param.append("excelFile", file.file);
      console.log(file.file);
      const url = "aocampaignsales/openapi/sales/activity-store/bulk-import-not-save?activityId=" + this.activityId + "&uuId=" + this.uuId;
      this.$http
        .post(url, param, {
          headers: {
            Authorization: `Bearer ${this.$route.query.token}`,
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => {
          console.log("res:", res);
          this.$Toast.success("上传成功");
          // window.wx.miniProgram.postMessage({ data: res.data });
          setTimeout(() => {
            window.wx.miniProgram.navigateBack();
          }, 1000);
        })
        .catch((err) => {
          console.log("err:", err.response.data.message);
          // this.$Toast("上传失败");
          this.$Toast.clear();
          this.showError(err.response.data.message);
        });
    },
    showError(message) {
      this.$Dialog.alert({
        title: "",
        message: message ? message : "上传失败",
        confirmButtonText: "确定",
        confirmButtonColor: "#1F7DDE",
        width: "310px",
      });
    },
  },
  mounted() {
    this.activityId = this.$route.query.activityId ? this.$route.query.activityId : "";
    this.uuId = this.$route.query.uuId ? this.$route.query.uuId : "";
  },
};
</script>

<style lang="less" scoped>
.power {
  background: #f7f8fa;
  height: 100vh;
}
.van-cell-group {
  border-radius: 5px;
  overflow: hidden;
}
</style>
